var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187515",
    "data-name": "Group 187515",
    transform: "translate(-558 -875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187514",
    "data-name": "Group 187514",
    transform: "translate(232.991 608.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325.009 266.26)",
    fill: "#fbf2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-information-circle-outline",
    "data-name": "Icon ionic-md-information-circle-outline",
    transform: "translate(564.625 881.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37704",
    "data-name": "Path 37704",
    d: "M13,5.319A7.678,7.678,0,1,1,7.567,7.567,7.65,7.65,0,0,1,13,5.319m0-1.944A9.625,9.625,0,1,0,22.625,13,9.624,9.624,0,0,0,13,3.375Z",
    transform: "translate(0 0)",
    fill: "#61277f",
    stroke: "#fbf2ff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37705",
    "data-name": "Path 37705",
    d: "M18.467,20.312H16.523V14.528h1.944Zm0-7.681H16.523V10.688h1.944Z",
    transform: "translate(-4.495 -2.5)",
    fill: "#61277f",
    stroke: "#fbf2ff",
    strokeWidth: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b779f485f7a5faf4547841554b7d9b5c.svg";
export { ForwardRef as ReactComponent };